// Tracking Statuses
const TrackingStatus = {
    Preparing: "preparing",
    InTransit: "intransit",
    InTransitNoEstimation: "intransit-noarrival-estimation",
    Delivered: "delivered",
    Exception: "exception",
    Unknown: "unknown",
    Cancelled: "cancelled",
}

// Mothership Statuses
const MothershipStatus = {
    Unallocated: "Unallocated",
    FindingDriver: "FindingDriver",
    DriverAllocated: "DriverAllocated",
    EnrouteToPickup: "EnrouteToPickup",
    ArrivedAtPickup: "ArrivedAtPickup",
    EnrouteToDelivery: "EnrouteToDelivery",
    ArrivedAtDelivery: "ArrivedAtDelivery",
    Completed: "Completed",
    DeliveryConfirmation: "DeliveryConfirmation",
    Cancelled: "Cancelled",
}

// Echo Status
const EchoStatus = {
    Ordered: "ORDERED",
    Booked: "BOOKED",
    CheckedIn: "CHECKEDIN",
    Loading: "LOADING",
    PickedUp: "PICKEDUP",
    Unloading: "UNLOADING",
    Delivered: "DELIVERED",
    Cancelled: "CANCELLED",
}

const StandardStatus = {
    Created: "label_create",
    Departed: "scanned",
    OutForDelivery: "out_for_delivery",
    Delivered: "delivered",
    MissedDelivery: "missed",
    Delayed: "delayed",
    Exception: "exception",
    InTransit: "in_transit",
    Cancelled: "cancelled",
    Unknown: "unknown",
}

export { TrackingStatus, MothershipStatus, EchoStatus, StandardStatus }
